(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hint-card-buy"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__hintCardBuyReady) return;
    window.__hintCardBuyReady = true;

    var routes = (window.Theme && window.Theme.routes) || {};
    var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
    var cartUrl = (routes.cart_url || '/cart');

    function setMsg(root, html, isError) {
      var el = root.querySelector('.hint-card-buy__msg');
      if (!el) return;
      el.classList.toggle('hint-card-buy__msg--error', !!isError);
      el.innerHTML = html;
      clearTimeout(el._hcbTimer);
      if (!isError) {
        el._hcbTimer = setTimeout(function () { el.innerHTML = ''; }, 6000);
      }
    }

    function needsVariant(root) {
      var select = root.querySelector('.hint-card-buy__variant');
      if (select && !select.value) {
        select.classList.add('hint-card-buy__variant--invalid');
        setMsg(root, 'Escolha uma opção antes de continuar.', true);
        select.focus();
        return true;
      }
      return false;
    }

    // Impede que cliques nos controles abram a pagina do produto
    document.addEventListener('click', function (event) {
      var root = event.target.closest && event.target.closest('[data-hint-card-buy]');
      if (!root) return;
      event.stopPropagation();

      var step = event.target.closest('[data-hcb-step]');
      if (step) {
        event.preventDefault();
        var input = root.querySelector('input[name="quantity"]');
        var value = parseInt(input.value, 10) || 1;
        value = Math.max(1, Math.min(99, value + parseInt(step.getAttribute('data-hcb-step'), 10)));
        input.value = value;
        return;
      }

      var addButton = event.target.closest('[data-hcb-add]');
      if (addButton) {
        event.preventDefault();
        addToCart(root, addButton);
      }
    }, true);

    // Ao escolher tamanho/cor: tira o aviso e mostra a foto da variante no card
    function showVariantImage(select) {
      var option = select.options[select.selectedIndex];
      var img = option && option.getAttribute('data-img');
      if (!img) return;
      var card = select.closest('product-card');
      if (!card) return;
      var slideshow = card.querySelector('slideshow-component');
      var firstSlide = card.querySelector('slideshow-slide');
      var target = (firstSlide || card).querySelector('img');
      if (!target) return;
      if (!target.dataset.hcbOriginalSrc) {
        target.dataset.hcbOriginalSrc = target.getAttribute('src') || '';
        target.dataset.hcbOriginalSrcset = target.getAttribute('srcset') || '';
      }
      target.setAttribute('srcset', option.getAttribute('data-srcset') || '');
      target.setAttribute('src', img);
      if (slideshow && typeof slideshow.select === 'function') {
        try { slideshow.select(0); } catch (e) {}
      }
    }

    document.addEventListener('change', function (event) {
      if (event.target.classList && event.target.classList.contains('hint-card-buy__variant')) {
        event.target.classList.remove('hint-card-buy__variant--invalid');
        var root = event.target.closest('[data-hint-card-buy]');
        if (root) setMsg(root, '', false);
        showVariantImage(event.target);
      }
    });

    // "Comprar": valida a variante antes de seguir para o checkout
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.classList || !form.classList.contains('hint-card-buy__form')) return;
      var root = form.closest('[data-hint-card-buy]');
      if (needsVariant(root)) {
        event.preventDefault();
        return;
      }
      var buy = form.querySelector('.hint-card-buy__btn--buy');
      if (buy) {
        buy.disabled = true;
        buy.textContent = 'Indo para o pagamento…';
      }
    }, true);

    async function addToCart(root, button) {
      if (needsVariant(root)) return;

      var form = root.querySelector('form');
      var id = form.querySelector('[name="id"]').value;
      var quantity = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
      var label = button.querySelector('[data-hcb-label]') || button;
      var originalHTML = label.innerHTML;

      button.disabled = true;
      label.textContent = 'Adicionando…';

      var events = null;
      var deferred = null;
      try {
        events = await import('@shopify/events');
        deferred = events.CartLinesUpdateEvent.createPromise();
        root.dispatchEvent(new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity: quantity }],
          promise: deferred.promise
        }));
      } catch (e) {
        events = null;
        deferred = null;
      }

      try {
        var response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
        });
        var data = await response.json();
        var failed = !response.ok || !!data.status;

        var cart = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });

        if (deferred && events) {
          deferred.resolve({
            cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              itemCount: quantity,
              source: 'hint-card-buy',
              didError: failed
            }
          });
        }

        if (failed) {
          setMsg(root, data.description || data.message || 'Não foi possível adicionar este item.', true);
        } else {
          setMsg(root, 'Adicionado ao carrinho ✓ <a href="' + cartUrl + '">Ver carrinho</a>', false);
        }
      } catch (error) {
        if (deferred) deferred.reject(error);
        setMsg(root, 'Erro de conexão. Tente novamente.', true);
      } finally {
        button.disabled = false;
        label.innerHTML = originalHTML;
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
